import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { StandardClientNames } from '@models';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OrgClientService {
  private http: HttpClient = inject(HttpClient);

  getStandardClientNames(userId: string, orgIds: string[]): Observable<StandardClientNames> {
    const BASE_URL = environment.CRG_DIGITALIZATION_SERVICE_URL;
    const GET_CLIENT_NAMES_URL = `${BASE_URL}/crg-sponsor-portal-service/api/v1/org-client/get-client-names`;
    const params = new HttpParams().set('user_id', userId).set('org_ids', orgIds.join(','));
    return this.http.get<StandardClientNames>(GET_CLIENT_NAMES_URL, {
      withCredentials: true,
      params
    });
  }
}
